<template>
  <b-container fluid class="container-nav-bar">
    <b-navbar type="light" variant="light" class="nav-bar-premium" fixed="top">
      <b-navbar-nav class="navbar navbar-light navbar-expand-sm">

        <b-nav-item
          href="#"
          class="nav-link-premium"
          @click="
            backToMyAccount();
            set_active = 'my_account_details';
          "
          :class="
            set_active === 'my_account_details' ? 'nav-link-premium-active' : ''
          "
          >MY ACCOUNT DETAILS</b-nav-item
        >
        <b-nav-item
          href="#"
          class="nav-link-premium"
          @click="
            goToPremiumPage();
            set_active = 'thrive_with_dropsmart';
          "
          :class="
            set_active === 'thrive_with_dropsmart'
              ? 'nav-link-premium-active'
              : ''
          "
          >THRIVE WITH DROPSMART</b-nav-item
        >
        <b-nav-item
          v-if="false"
          href="#"
          class="nav-link-premium"
          @click="
            goToFriendReferrals();
            set_active = 'friend_referrals';
          "
          :class="
            set_active === 'friend_referrals' ? 'nav-link-premium-active' : ''
          "
          >FRIEND REFERRALS</b-nav-item
        >
        <b-nav-item
          v-if="false"
          href="#"
          class="nav-link-premium"
          @click="
            goToPerks();
            set_active = 'perks';
          "
          :class="
            set_active === 'perks' ? 'nav-link-premium-active' : ''
          "
          >PERKS</b-nav-item
        >

      </b-navbar-nav>
    </b-navbar>
  </b-container>
</template>

<script>
export default {
  name: "HeaderNavBar",
  props: ["activeLink", "customerInfo"],
  data() {
    return {
      set_active: this.activeLink,
      isPaidUser: JSON.parse(sessionStorage.getItem("customerInfo")).user.paid,
    };
  },
  components: {},
  computed: {},
  methods: {
    backToMyAccount: function() {
      this.$router.push("/center/my-account");
    },
    goToPremiumPage: function() {
      console.log("HEADER NAV BAR MENU - PAID attribute: " + this.customerInfo.user.paid);
      this.$router.push({
        name: "MyPremiumMaterial",
        query: { step: 1 },
      });
    },
    goToFriendReferrals: function() {
      this.$router.push({
        name: "FriendReferrals",
      });
    },
    goToPerks: function() {
      this.$router.push({
        name: "Perks",
      });
    }
  },
};
</script>

<style scoped lang="scss">
//Those properties are setted as scoped as well as the Header.vue
//in order to be encapsulated in its own components

.container-nav-bar {
  .nav-bar-premium {
    justify-content: flex-start;
    padding: 0.5rem 1rem;
    padding-left: 3.2rem;
    font-size: 18px;

    .nav-link-premium {
      padding-left: 6px;
      padding-right: 6px;

      a:hover {
        color: #79b867;
      }
    }

    .nav-link-premium-active {
      color: #000000;
      font-weight: 700;
    }
  }
}

@media screen and (max-width: 600px) {
  .nav-bar-premium {
    padding: 8px 16px;
    ul {
      align-items: baseline;
    }
    ul.navbar-expand-sm {
      flex-direction: column;
      padding: 8px 0;

    }
    
  }
  
}
</style>
